module.exports = __webpack_public_path__ + "resources/images/stopcontact-fc73febdd9f5a4d330eebe69a2f3ba57-cache.jpg";